import { getPhoneFromToken } from '../helpers/decodeJWT'
import { phoneAuthService } from './phone-auth'
import {
  SessionResponseSchema,
  SessionFullResponseSchema,
  WrappedSessionResponseSchema,
  safeParseCompletedTutorials,
  safeStringifyCompletedTutorials,
} from './session-validation'

const SESSION_TYPE = 'WC_SESSION'
const base = process.env.REACT_APP_SESSIONS_API_BASE

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken')
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  }
}

const apiClient = async ({ url, method, body }) => {
  const response = await fetch(url, {
    method,
    headers: getAuthHeaders(),
    ...(body && { body }),
  })
  if (response.status === 401) {
    // not authorized
    phoneAuthService.clearAuth()
    window.location.replace('/registration')
    return null
  }
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('NotFound')
    }
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const responseData = await response.json()
  return responseData
}

export const fetchSession = async ({ initialData }) => {
  try {
    const responseData = await apiClient({
      url: `${base}/public/sessions/${SESSION_TYPE}`,
      method: 'GET',
    })

    const { data: [validated] } = SessionResponseSchema.parse(responseData)
    const parsedData = safeParseCompletedTutorials(
      validated.data.completedTutorials,
    )

    return { completedTutorials: parsedData, sessionId: validated.sessionId }
  } catch (error) {
    if (error?.message === 'NotFound') {
      const newSession = await createSession(initialData)
      return { sessionId: newSession.sessionId }
    }
    console.error('Error fetching session:', error)
    return initialData
  }
}

export const createSession = async (completedTutorials) => {
  try {
    const completedTutorialsString = safeStringifyCompletedTutorials(completedTutorials)

    const body = JSON.stringify({
      sessionDefinitionType: SESSION_TYPE,
      data: {
        completedTutorials: completedTutorialsString,
      },
    })
    const response = await apiClient({
      url: `${base}/public/sessions`,
      method: 'POST',
      body,
    })

    const validated = WrappedSessionResponseSchema.parse(response)
    return validated.data
  } catch (error) {
    console.error('Error creating session:', error)
    return null
  }
}

export const updateSession = async ({ completedTutorials, sessionId }) => {
  try {
    const completedTutorialsString = safeStringifyCompletedTutorials(completedTutorials)

    const body = JSON.stringify({
      completedTutorials: completedTutorialsString,
    })

    const response = await apiClient({
      url: `${base}/public/sessions/${sessionId}`,
      method: 'PUT',
      body,
    })
    const validated = WrappedSessionResponseSchema.parse(response)
    return validated.data
  } catch (error) {
    console.error('Error updating session:', error)
    return null
  }
}
